// The Library's upload queue (state.libraryUploads). Rows are plain objects,
// not frozen: the scheduler in actions/libraryFiles.js patches progress and
// status on them as each upload runs.

export const ADD_LIBRARY_UPLOADS = (state, items) => {
  state.libraryUploads.push(...items);
};

export const UPDATE_LIBRARY_UPLOAD = (state, { id, ...patch }) => {
  const row = state.libraryUploads.find((upload) => upload.id === id);
  if (row) {
    Object.assign(row, patch);
  }
};

export const REMOVE_LIBRARY_UPLOAD = (state, id) => {
  const index = state.libraryUploads.findIndex((upload) => upload.id === id);
  if (index >= 0) {
    state.libraryUploads.splice(index, 1);
  }
};

// Drops the rows that are finished (done or failed); pending and running
// uploads stay.
export const CLEAR_FINISHED_LIBRARY_UPLOADS = (state) => {
  state.libraryUploads = state.libraryUploads.filter(
    (upload) => upload.status === "pending" || upload.status === "uploading"
  );
};
